(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["autoplay_video"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Ensure video autoplays in Safari and other browsers
  document.addEventListener('DOMContentLoaded', function() {
    const video = document.querySelector('.autoplay_video .video---background');
    if (video) {
      // Force play for Safari compatibility
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function(error) {
          // Auto-play was prevented, try again on user interaction
          console.log('Video autoplay prevented:', error);
          // Try to play on first user interaction
          const playOnInteraction = function() {
            video.play().catch(function(err) {
              console.log('Video play failed:', err);
            });
            document.removeEventListener('click', playOnInteraction);
            document.removeEventListener('touchstart', playOnInteraction);
          };
          document.addEventListener('click', playOnInteraction, { once: true });
          document.addEventListener('touchstart', playOnInteraction, { once: true });
        });
      }
      
      // Ensure video is muted for autoplay policies
      video.muted = true;
      
      // Handle video errors
      video.addEventListener('error', function(e) {
        console.error('Video error:', e);
      });
      
      // Ensure video loops
      video.loop = true;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
// Prevent navigation for menu items with dropdowns
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var menuItemsWithDropdowns = document.querySelectorAll('.Header__MainNav .HorizontalList__Item[aria-haspopup="true"] > a');
    
    menuItemsWithDropdowns.forEach(function(link) {
      // Prevent navigation on click for items with dropdowns
      link.addEventListener('click', function(e) {
        // Only prevent if dropdown is not already open (to allow closing)
        var parentItem = this.closest('.HorizontalList__Item');
        var dropdown = parentItem.querySelector('.DropdownMenu, .MegaMenu');
        
        if (dropdown && dropdown.getAttribute('aria-hidden') === 'true') {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }, false);
      
      // Also prevent navigation on mouse click if dropdown exists
      link.addEventListener('mousedown', function(e) {
        var parentItem = this.closest('.HorizontalList__Item');
        var dropdown = parentItem.querySelector('.DropdownMenu, .MegaMenu');
        
        if (dropdown) {
          // Allow right-click and middle-click to work normally
          if (e.button === 0) { // Left click only
            e.preventDefault();
          }
        }
      }, false);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
